import {
    UPDATE_IS_MOBILE_SIZE,
    UPDATE_WINDOW_SIZE,
    UPDATE_SEARCH_CENTER,
    UPDATE_SEARCH_MOBILE_SIZE,
    UPDATE_RENDER_STATUS
} from '../mutation-types';
import { searchCenter as isSearchCenter } from './center-adapt';

export default {
    state: {
        isMobileSize: false,
        isSearchMobileSize: false,
        isSearchCenter: false,
        renderStatus: 3, //  页面运行时的状态    1 正在服务端渲染  2 服务端渲染，客户端激活(也就是服务端渲染的首页) 3. 客户端渲染(纯客户端渲染，或者在客户端单页跳转后的页面)
        windowSize: {
            width: window.innerWidth,
            height: window.innerHeight
        }
    },
    getters: {
        soldListingFlag(state) {
            if (state.isSearchCenter) {
                return '4';
            } else {
                return '1';
            }
        }
    },
    mutations: {
        [UPDATE_WINDOW_SIZE](state) {
            state.windowSize = {
                width: window.innerWidth,
                height: window.innerHeight
            };
        },
        [UPDATE_RENDER_STATUS](state, payload) {
            state.renderStatus = payload;
        },
        [UPDATE_IS_MOBILE_SIZE](state, isMobileSize) {
            if (isMobileSize !== state.isMobileSize) {
                state.isMobileSize = isMobileSize;
            }
        },
        [UPDATE_SEARCH_MOBILE_SIZE](state, isMobileSize) {
            if (isMobileSize !== state.isSearchMobileSize) {
                state.isSearchMobileSize = isMobileSize;
            }
        },
        [UPDATE_SEARCH_CENTER](state, searchCenter) {
            state.isSearchCenter = searchCenter;
            isSearchCenter.searchCenter = searchCenter;
            isSearchCenter.soldListingFlag = '4';
        }
    }
};
